import { Auth as BaseAuth } from '@link/gds-share/stores';

export class Auth extends BaseAuth {}
export type AuthType = Auth;
export default new Auth();
